import { render, staticRenderFns } from "./more-input-data-form.vue?vue&type=template&id=59b731e1"
import script from "./more-input-data-form.vue?vue&type=script&lang=js"
export * from "./more-input-data-form.vue?vue&type=script&lang=js"
import style0 from "./more-input-data-form.vue?vue&type=style&index=0&id=59b731e1&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports